<template>
  <transition name="fade">
    <div v-if="menuVisible" class="no-top-radius shadow" style="color: #343a40;">
      <div class="pt-0 pl-0 pr-0 accordion no-top-radius " role="tablist">
        <b-card no-body class="py-0 border-top-0 border-left-0 no-top-radius" v-for="section in menuParsed.sections" :key="section.id">

          <b-card-header header-tag="header" class="p-0 bg-light" role="tab" style="cursor: default !important;">
            <b-button block variant="secondary" class="no-glow py-2" :id="section.id"
                      :data-test-path="section.id" tabindex="0" style="pointer-events: none; cursor: default !important;">

              <b-container class="w-100">
                <b-row no-gutters class="w-100">
                  <b-col cols="2" class="justify-content-center text-center">
                    <font-awesome-icon v-if="section.icon" :icon="section.icon" class="fixed-icon mr-2"/>
                  </b-col>
                  <b-col  cols="auto">{{ section.label }}</b-col>
                </b-row>
              </b-container>

            </b-button>
          </b-card-header>

          <!--          <b-collapse :id="section.accordionId" :visible="section.open" accordion="menu-accordion" role="tabpanel">-->
          <!--          </b-collapse>-->
          <b-card-body class="py-1 bg-light">

            <b-nav-item v-for="menuItem in section.items" :key="menuItem.id"
                        class="nav-link py-0 px-md-0"
                        :id="menuItem.id"
                        :data-test-path="menuItem.id"
                        link-classes="text-primary"
                        href=""
                        v-if="menuItem.hasPermission"
                        @click="execute(menuItem)">
              <font-awesome-icon :icon="menuItem.icon" class="fixed-icon mr-2"/>
              {{menuItem.label}}
            </b-nav-item>
          </b-card-body>
        </b-card>
      </div>

    </div>
  </transition>
</template>

<style lang="sass" scoped>
.no-glow:focus
  outline: 0 !important
  box-shadow: 0 0 0 0 !important
  border: none !important
  border-radius: unset !important

.no-glow
  box-shadow: 0 0 0 0 !important
  border: none !important
  border-radius: unset !important

.no-top-radius
  border-top-left-radius: unset !important
  border-top-right-radius: unset !important
  border-bottom-left-radius: unset !important

.fixed-icon
  width: 1em
  height: 1em

</style>
<script>
import {getMenu} from "@/components/dashboard/menu/MenuContent";


export default {
  name: "RightMenu",

  async created() {
    this.login = SessionManager.login;

  },

  methods: {
    execute(menuItem) {
      if (menuItem.action) {
        Rpc.Interactions.event("right-menu", {name: menuItem.id}).then();
        menuItem.action();
      }
    },

  },

  props: {
    menuVisible:           {type: Boolean,  default: false },
    menu:                  {default: null},
  },

  data: function(){
    return {
      login: "",
      menuParsed: getMenu(this.menu),
    }
  },
}

</script>
